import { IMAGES_PATH } from 'themes'

const btcLogo = IMAGES_PATH('/ledgers/btcIcon.svg')
const goldLogo = IMAGES_PATH('/ledgers/xauOval.svg')
const silverLogo = IMAGES_PATH('/ledgers/xagOval.svg')
const platinumLogo = IMAGES_PATH('/ledgers/xptOval.svg')

const ethLogo = IMAGES_PATH('/ledgers/ethOval.svg')
const usdcLogo = IMAGES_PATH('/ledgers/usdcOval.svg')
const usdtLogo = IMAGES_PATH('/ledgers/usdtOval.svg')
const solLogo = IMAGES_PATH('/ledgers/solOval.svg')
const atriLogo = IMAGES_PATH('/ledgers/atriOval.svg')
const xrpLogo = IMAGES_PATH('/ledgers/xrpOval.svg')
const usduLogo = IMAGES_PATH('/ledgers/usduOval.svg')
const cruLogo = IMAGES_PATH('/ledgers/cruOval.svg')
const adaLogo = IMAGES_PATH('/ledgers/adaOval.svg')
const dogeLogo = IMAGES_PATH('/ledgers/dogeOval.svg')
const eosLogo = IMAGES_PATH('/ledgers/eosOval.svg')
const rlxLogo = IMAGES_PATH('/ledgers/rlxOval.svg')
const shibLogo = IMAGES_PATH('/ledgers/shibOval.svg')
const vetLogo = IMAGES_PATH('/ledgers/vetOval.svg')
const pauxLogo = IMAGES_PATH('/ledgers/pauxOval.svg')
const paugLogo = IMAGES_PATH('/ledgers/paugOval.svg')
const ftmLogo = IMAGES_PATH('/ledgers/ftmOval.svg')
const untbLogo = IMAGES_PATH('/ledgers/untbOval.svg')
const wcruLogo = IMAGES_PATH('/ledgers/wcruOval.svg')
const dwrldLogo = IMAGES_PATH('/ledgers/dwrldOval.svg')
const trxLogo = IMAGES_PATH('/ledgers/trxOval.svg')
const air777Logo = IMAGES_PATH('/ledgers/air777Oval.svg')
const mt777Logo = IMAGES_PATH('/ledgers/mt777Oval.svg')
const mt760Logo = IMAGES_PATH('/ledgers/mt760Oval.svg')
const gxagLogo = IMAGES_PATH('/ledgers/gxagOval.svg')
const lif3Logo = IMAGES_PATH('/ledgers/lif3Oval.svg')
const wbtcLogo = IMAGES_PATH('/ledgers/wbtcOval.svg')

const eur = IMAGES_PATH('/ledgers/eurOval.svg')
const usd = IMAGES_PATH('/ledgers/usdOval.svg')
const chf = IMAGES_PATH('/ledgers/chfOval.svg')
const sgd = IMAGES_PATH('/ledgers/sgdOval.svg')
const gbp = IMAGES_PATH('/ledgers/gbpOval.svg')
const aed = IMAGES_PATH('/ledgers/aedOval.svg')

const enLang = IMAGES_PATH('/lang/en.svg')
const esLang = IMAGES_PATH('/lang/es.svg')
const frLang = IMAGES_PATH('/lang/fr.svg')
const itLang = IMAGES_PATH('/lang/it.svg')
const ruLang = IMAGES_PATH('/lang/ru.svg')
const ltLang = IMAGES_PATH('/lang/lt.svg')
const deLang = IMAGES_PATH('/lang/de.svg')
const arLang = IMAGES_PATH('/lang/ar.svg')
const zhLang = IMAGES_PATH('/lang/cn.svg')
const urlang = IMAGES_PATH('/lang/in.svg')
const trLang = IMAGES_PATH('/lang/tr.svg')

export const selectedLanguageImage = {
    en: enLang,
    ru: ruLang,
    es: esLang,
    fr: frLang,
    it: itLang,
    lt: ltLang,
    de: deLang,
    ar: arLang,
    zh: zhLang,
    ur: urlang,
    tr: trLang,
}

export const businessImg = IMAGES_PATH('/business.svg')
export const refresh = IMAGES_PATH('/refreshGrey.svg')
export const commentCloud = IMAGES_PATH('/commentCloud.svg')
export const warningCloud = IMAGES_PATH('/warningCloud.svg')
export const profileAvatar = IMAGES_PATH('/profile-oval-dark-grey.svg')
export const creditCard = IMAGES_PATH('/credit-card-dark-grey.svg')
export const uploadDocs = IMAGES_PATH('/upload-documents.svg')
export const bankAccountOval = IMAGES_PATH('/bankAccountRoundDarkGrey.svg')
export const arrowKeyboardRight = IMAGES_PATH('/arrowKeyboardRight.svg')
export const fileIconOval = IMAGES_PATH('/file-icon-oval.svg')
export const securityWarningFab = IMAGES_PATH('/security-warn-fab.svg')
export const warningTriangle = IMAGES_PATH('/warning-triangle.svg')
export const dashboardIcon = IMAGES_PATH('/dashboardLinkIcon.svg')
export const addAccountSvg = IMAGES_PATH('/add-account.svg')
export const settingsIcon = IMAGES_PATH('/settingsLinkIcon.svg')
export const transactionsIcon = IMAGES_PATH('/transactionsLinkIcon.svg')
export const cardIcon = IMAGES_PATH('/card.svg')
export const bankAccountOvalWhite = IMAGES_PATH('/bankAccountOvalWhite.svg')
export const cardActiveOvalWhite = IMAGES_PATH('/CardActiveOvalWhite.svg')
export const cardFrozenOvalWhite = IMAGES_PATH('/CardFrozenOvalWhite.svg')
export const sepaOval = IMAGES_PATH('/sepaOval.svg')
export const swiftOval = IMAGES_PATH('/swiftOval.svg')
export const ukLocalOval = IMAGES_PATH('/ukLocalOval.svg')
const basket = IMAGES_PATH('/basketGrey.svg')
const plusGrey = IMAGES_PATH('/plus-grey.svg')
const transfer = IMAGES_PATH('/transfer.svg')
const priceTag = IMAGES_PATH('/priceTag.svg')
const floatingCard = IMAGES_PATH('/floatingCard.svg')
const pencilImg = IMAGES_PATH('/pencil.svg')
const shippingImg = IMAGES_PATH('/shipping.svg')
const refundImg = IMAGES_PATH('/refund.svg')

export const multichainNetworks = {
    Ethereum: {
        name: 'Ethereum',
        protocol: 'ERC-20',
    },
    Tron: {
        name: 'Tron',
        protocol: 'TRC-20',
    },
    Solana: {
        name: 'Solana',
        protocol: 'SPL',
    },
}

export const currencyImages = {
    EUR: eur,
    USD: usd,
    CHF: chf,
    GBP: gbp,
    SGD: sgd,
    AED: aed,
    BTC: btcLogo,
    WBTC: wbtcLogo,
    ETH: ethLogo,
    USDC: usdcLogo,
    USDT: usdtLogo,
    SOL: solLogo,
    XPT: platinumLogo,
    XAG: silverLogo,
    XAU: goldLogo,
    ATRI: atriLogo,
    XRP: xrpLogo,
    CRU: cruLogo,
    USDU: usduLogo,
    UNTB: untbLogo,
    ADA: adaLogo,
    DOGE: dogeLogo,
    EOS: eosLogo,
    RLX: rlxLogo,
    SHIB: shibLogo,
    VET: vetLogo,
    PAUX: pauxLogo,
    PAUG: paugLogo,
    FTM: ftmLogo,
    WCRU: wcruLogo,
    DWRLD: dwrldLogo,
    TRX: trxLogo,
    AIR777: air777Logo,
    MT777: mt777Logo,
    MT760: mt760Logo,
    GXAG: gxagLogo,
    LIF3: lif3Logo,
}

export const MetalLogos = {
    xpt: platinumLogo,
    xag: silverLogo,
    xau: goldLogo,
}

export const MetalLogos2 = {
    XPT: platinumLogo,
    XAG: silverLogo,
    XAU: goldLogo,
}

export const metalCodeToName = {
    xpt: 'Platinum',
    xag: 'Silver',
    xau: 'Gold',
}

export const metalCodeToName2 = {
    XPT: 'Platinum',
    XAG: 'Silver',
    XAU: 'Gold',
}

export const metalCodeToNameWithG = {
    XPT: 'g Platinum',
    XAG: 'g Silver',
    XAU: 'g Gold',
}

export const serviceTypes = {
    CreditCard: 'CreditCards',
    Iban: 'BankAccounts',
    TradingDesk: 'TradingDesk',
    TradingDeskCrypto: 'TradingDesk',
    DigitalAsset: 'DigitalAssets',
    Metal: 'Metals',
    XCurrency: 'Basic',
    LimitedToken: 'LimitedTokens',
}

export const determineImage = currency => currencyImages[currency]

export const modalTransferIcons = {
    CreditCardTopUp: plusGrey,
    IbanDepositFromAssets: plusGrey,
    IbanDepositFromBankInternational: plusGrey,
    IbanDepositFromBankSepa: plusGrey,
    CreditCardWithdraw: transfer,
    CreditCardPurchase: basket,
    PhysicalCreditCardPurchase: basket,
    PhysicalLimitlessCreditCardPurchase: basket,
    IbanWithdrawalToAssets: transfer,
    IbanWithdrawalToBank: transfer,
    IbanWithdrawalToBankInternational: transfer,
    FirstIbanRequest: basket,
    IbanRequest: basket,
    IbanWithdrawalToBankSepa: transfer,
    DepositCurrencyBySepaBank: plusGrey,
    DepositCurrencyByInternationalBank: plusGrey,
    DepositCurrencyByFastBank: plusGrey,
    DepositCurrencyByOnline: plusGrey,
    DepositCurrencyByCard: plusGrey,
    DepositCurrency: plusGrey,
    VirtualCreditCardPurchase: basket,
    BalanceAdjustment: pencilImg,
    CurrencyWithdrawSepa: transfer,
    AssetTransfer: 'Asset Transfer',
    ExchangeCurrencyToCurrency: refresh,
    InternalAssetTransfer: transfer,
    InternalPaymentTransfer: transfer,
    TradingDeskDeposit: plusGrey,
    TradingDeskBuyCrypto: basket,
    TradingDeskWithdrawal: transfer,
    TradingDeskSellCrypto: basket,
    TradingDeskCryptoWithdrawal: transfer,
    TradingDeskCryptoDeposit: plusGrey,
    FeeBasket: priceTag,
    ExchangeCurrencyToMetal: refresh,
    ExchangeMetalToCurrency: refresh,
    CreditCardStatement: floatingCard,
    CardAtmWithdrawal: floatingCard,
    CardAuthorization: floatingCard,
    CurrencyWithdrawInternational: transfer,
    CompanyRegistration: businessImg,
    RecurringAccountFee: priceTag,
    DelayedCompanyOnboardingFee: priceTag,
    DelayedIbanFee: priceTag,
    Onboarding: priceTag,
    DigitalAssetsExchange: refresh,
    DigitalAssetsWithdrawal: transfer,
    DigitalAssetsDeposit: plusGrey,
    DigitalAssetsBuy: basket,
    DigitalAssetsSell: basket,
    LimitedTokenSell: basket,
    LimitedTokenInternalTransfer: transfer,
    LimitedTokenBuy: basket,
    VirtualAddressBuy: basket,
    CreditCardShipping: shippingImg,
    LimitedTokenWithdrawal: transfer,
    IbanInternalTransfer: transfer,
    Refund: refundImg,
    VirtualAddressForwardingCost: priceTag,
    IbanDepositFromCard: plusGrey,
}
